export default __webpack_public_path__ + "static/media/qtx_logo_small.114124ab.svg";